import React from 'react';
import { useIsMobile } from '../../hooks';
import { City } from '../../interfaces/config';

import { CityAutocompleteDesktop } from './CityAutocompleteDesktop';
import { CityAutocompleteMobile } from './CityAutocompleteMobile';

export interface CityAutocompleteProps {
    appType: 'worker' | 'employer' | 'recruiter';
    options: City[] | null;
    selectedOption: City | null;
    errors?: string[];
    tabIndex?: number;
    onSearch: (value: string) => void;
    setSearchOptions: (value: City[] | null) => void;
    onSelect: (value: City | null) => void;
}

export const CityAutocomplete = (props: CityAutocompleteProps) => {
    const isMobile = useIsMobile();

    if (isMobile) {
        return <CityAutocompleteMobile {...props} />;
    }

    return <CityAutocompleteDesktop {...props} />;
};
